import React from "react";

// Inline SVG glyphs for the four NWS condition buckets used by the
// weather-by-zone feature: 'sunny' | 'cloudy' | 'rainy' | 'lightning'.
// Emoji-free, currentColor-driven so the chip controls color via CSS.
// `size` defaults to 14px to sit inline with chip text.

const Sunny = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
    <circle cx="12" cy="12" r="4.5" fill="currentColor" />
    {[0, 45, 90, 135, 180, 225, 270, 315].map((deg) => {
      const r = (deg * Math.PI) / 180;
      const x1 = 12 + Math.cos(r) * 7;
      const y1 = 12 + Math.sin(r) * 7;
      const x2 = 12 + Math.cos(r) * 9.5;
      const y2 = 12 + Math.sin(r) * 9.5;
      return (
        <line
          key={deg}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      );
    })}
  </svg>
);

const Cloudy = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
    <path
      d="M7 18h9.5a3.5 3.5 0 0 0 .4-6.98A5 5 0 0 0 7.2 10.2 4 4 0 0 0 7 18z"
      fill="currentColor"
    />
  </svg>
);

const Rainy = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
    <path
      d="M7 14h9.5a3.5 3.5 0 0 0 .4-6.98A5 5 0 0 0 7.2 6.2 4 4 0 0 0 7 14z"
      fill="currentColor"
    />
    {[8, 12, 16].map((x) => (
      <line
        key={x}
        x1={x}
        y1="16"
        x2={x - 1.5}
        y2="20.5"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    ))}
  </svg>
);

const Lightning = ({ size = 14 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" focusable="false">
    <path
      d="M7 13h9.5a3.5 3.5 0 0 0 .4-6.98A5 5 0 0 0 7.2 5.2 4 4 0 0 0 7 13z"
      fill="currentColor"
    />
    <path
      d="M12.5 14l-3 4.2h2.2L10.5 22l4-5h-2.2l1.2-3z"
      fill="currentColor"
    />
  </svg>
);

const ICONS = {
  sunny: Sunny,
  cloudy: Cloudy,
  rainy: Rainy,
  lightning: Lightning,
};

/**
 * Render the glyph for a condition bucket. Unknown/absent condition falls
 * back to cloudy (neutral) so a partial weather row still shows something
 * sensible rather than blanking the icon.
 */
export const WeatherIcon = ({ condition, size = 14 }) => {
  const Cmp = ICONS[condition] || Cloudy;
  return <Cmp size={size} />;
};

export default WeatherIcon;
